<template>
    <span class="sip-callout-wrap">
        <p class="alert alert-info" v-if="!type">
            <span class="sip-callout-copy">
                <span class="sip-callout-label">Note</span>
                {{ trans(module + '.' + tip) }}
            </span>
        </p>
        <i class="fas fa-info-circle float-right" v-if="type"></i>
    </span>
</template>

<script>
    export default {
        props: ['tip','module','type']
    }
</script>
